const $maps = document.querySelectorAll( '.js-map' );

if ( $maps !== null ) {
  initMap();
}

window.mapInit = function() {
  [ ...$maps ].forEach( ( $map ) => loadMap( $map ));
};

function loadMap($map) {
  const coord = $map.getAttribute('data-coord').split(',');
  const zoom = $map.getAttribute('data-zoom') || 12;

  const myMap = new ymaps.Map( $map, {
    center: coord,
    zoom,
    controls: [ 'zoomControl', 'fullscreenControl', 'typeSelector', 'rulerControl' ]
  } );

  const myPlacemark1 = new ymaps.Placemark( coord, {}, {
    iconLayout: 'default#image',
    // iconImageHref: '../img/location.svg',
    // iconImageSize: [ 30, 40 ],
    // iconImageOffset: [ -3, -42 ],
  } );

  myMap.behaviors.disable( 'scrollZoom' );
  myMap.geoObjects.add( myPlacemark1 );
}


function initMap() {
  const script = document.createElement( "script" );
  script.type = "text/javascript";
  script.src = "https://api-maps.yandex.ru/2.1/?lang=ru_RU&onload=mapInit";
  document.getElementsByTagName( 'head' )[ 0 ].appendChild( script );
}
